import { apiGet, apiPut, apiDelete, ApiError } from '@/lib/api/client';
import type { HrmDashboardSummary, MyRosterSnapshot } from '@/types/hrm-dashboard';
import type { AdminDashboardConfig, HrmDashboardConfig } from '@/types/hrm-dashboard-config';

export async function getHrmDashboardSummary(): Promise<HrmDashboardSummary> {
  const env = await apiGet<HrmDashboardSummary>('/dashboard/summary');
  if (!env.data) {
    throw new Error('Dashboard summary not returned');
  }
  return env.data;
}

export async function getMyRosterSnapshot(): Promise<MyRosterSnapshot> {
  const env = await apiGet<MyRosterSnapshot>('/dashboard/my-roster');
  if (!env.data) {
    throw new Error('My roster snapshot not returned');
  }
  return env.data;
}

export async function getHrmDashboardConfig(): Promise<HrmDashboardConfig | null> {
  try {
    const env = await apiGet<HrmDashboardConfig>('/dashboard/config');
    return env.data ?? null;
  } catch (err) {
    if (err instanceof ApiError && err.status === 404) {
      return null;
    }
    throw err;
  }
}

export async function getAdminDashboardConfig(
  functionalRoleCode: string,
  levelRank: number
): Promise<AdminDashboardConfig> {
  const env = await apiGet<AdminDashboardConfig>(
    `/dashboard/config/admin/${encodeURIComponent(functionalRoleCode)}/${levelRank}`
  );
  if (!env.data) {
    throw new Error('Admin dashboard config not returned');
  }
  return env.data;
}

export async function upsertOrgDashboardConfig(
  body: Omit<HrmDashboardConfig, 'variantLabel'>
): Promise<void> {
  await apiPut('/dashboard/config', body);
}

export async function deleteOrgDashboardConfig(
  functionalRoleCode: string,
  levelRank: number
): Promise<void> {
  await apiDelete(`/dashboard/config/${encodeURIComponent(functionalRoleCode)}/${levelRank}`);
}
